import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PAGE_LONG, PAGE_SHORT } from "@/lib/listDensity";

/** Paginazione corta di default (20). Tasto per pagine da 50 se serve vedere di più. */
export const Pagination = ({ page, pages, total, onPage, pageSize, onPageSize }) => {
  if (!total) return null;
  return (
    <div className="flex items-center justify-between gap-3 mt-4 flex-wrap" data-testid="pagination">
      <button
        data-testid="page-prev"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
        className="h-10 px-4 bg-white border border-velta-border rounded-md text-sm font-medium inline-flex items-center gap-1.5 hover:border-velta-ink disabled:opacity-35 disabled:pointer-events-none btn-tactile"
      >
        <ChevronLeft className="w-4 h-4" /> Precedente
      </button>
      <span data-testid="page-info" className="text-sm font-mono text-velta-mute tabular-nums">
        Pagina {page} di {pages} · {total} element{total === 1 ? "o" : "i"}
      </span>
      <div className="flex items-center gap-2">
        {typeof onPageSize === "function" && (
          <button
            type="button"
            data-testid="page-density"
            onClick={() => onPageSize(pageSize === PAGE_LONG ? PAGE_SHORT : PAGE_LONG)}
            className="h-10 px-3 bg-white border border-velta-border rounded-md text-xs font-medium hover:border-velta-ink btn-tactile"
            title={pageSize === PAGE_LONG ? "Torna a 20 righe per pagina" : "Mostra 50 righe per pagina"}
          >
            {pageSize === PAGE_LONG ? "Pagine corte (20)" : "Pagine più lunghe (50)"}
          </button>
        )}
        <button
          data-testid="page-next"
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
          className="h-10 px-4 bg-white border border-velta-border rounded-md text-sm font-medium inline-flex items-center gap-1.5 hover:border-velta-ink disabled:opacity-35 disabled:pointer-events-none btn-tactile"
        >
          Successiva <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
